export const payoutConstants = {
	POST_PAYOUT_REQUEST: 		'POST_PAYOUT_REQUEST',
	POST_PAYOUT_SUCCESS: 		'POST_PAYOUT_SUCCESS',
	POST_PAYOUT_FAILURE: 		'POST_PAYOUT_FAILURE',
	GET_PAYOUTLIST_REQUEST: 	'GET_PAYOUTLIST_REQUEST',
	GET_PAYOUTLIST_SUCCESS: 	'GET_PAYOUTLIST_SUCCESS',
	GET_PAYOUTLIST_FAILURE: 	'GET_PAYOUTLIST_FAILURE',
	DELETE_PAYOUT_REQUEST: 		'DELETE_PAYOUT_REQUEST',
	DELETE_PAYOUT_SUCCESS: 		'DELETE_PAYOUT_SUCCESS',
	DELETE_PAYOUT_FAILURE: 		'DELETE_PAYOUT_FAILURE',
	GET_PAYOUT_REQUEST: 		'GET_PAYOUT_REQUEST',
	GET_PAYOUT_SUCCESS: 		'GET_PAYOUT_SUCCESS',
	GET_PAYOUT_FAILURE: 		'GET_PAYOUT_FAILURE',
}


// WEBPACK FOOTER //
// ./src/app/redux/constants/payoutConstants.js